<template>
  <div class="animated fadeIn">
    <template v-if="collection.length">
      <feeds-form
        v-for="(submission, index) in collection"
        :key="index"
        :submission="submission"
        :testPackageSamples="testPackageSamples"
        :addOns="addOns"
        :turnArounds="
          sampleType && sampleType.getTurnarounds()
            ? sampleType.getTurnarounds()
            : null
        "
        :serviceQuestions="
          sampleType && sampleType.getServiceQuestions()
            ? sampleType.getServiceQuestions()
            : null
        "
        :index="index"
        :typeOptions="type_options"
        :animalFedOptions="animal_fed_options"
        :managedListId="feedTypeOptionsId"
        @onSubmissionChange="onSubmissionChange"
        @removeSubmission="removeSubmission"
      ></feeds-form>
    </template>
    <b-button variant="success" block @click="newSubmission"
      ><i class="fal fa-plus"></i
    ></b-button>
  </div>
</template>

<script>
import FeedsForm from "./form/FeedsForm";
import Submission from "../../../models/legacy/Submission";
import TestPackageSampleCollection from "../../../collections/lab/TestPackageSampleCollection";
import TestPackageCollection from "../../../collections/lab/TestPackageCollection";
export default {
  name: "FeedsSubmissionForm",
  components: { FeedsForm },
  props: {
    submissions: {
      type: Array,
      default: () => []
    },
    testPackageSamples: {
      type: Object,
      default: () => new TestPackageSampleCollection()
    },
    testPackage: {
      type: Object,
      default: () => null
    },
    sampleType: {
      type: Object,
      default: () => null
    },
    managedLists: {
      type: Array,
      default: () => []
    },
    addOns: {
      type: Object,
      default: () => new TestPackageCollection()
    }
  },
  data() {
    return {
      collection: [],
      type_options: {},
      animal_fed_options: {}
    };
  },
  computed: {
    feedTypeOptionsId() {
      return this.managedLists.find((item) => item.sub_type === "feed" && item.list === "type").id
    }
  },
  methods: {
    createOptionList(list, field) {
      return {
        options: list.map(item => {
          return { id: item.id, name: item.value, parent_id: item.parent_id, managed_list_id: item.managed_list_id };
        }),
        field
      };
    },
    filterOptionList() {
      this.type_options = this.createOptionList(
        this.managedLists.find(
          item => item.sub_type === "feed" && item.list === "type"
        ).attribute_lists,
        "type"
      );
      this.animal_fed_options = this.createOptionList(
        this.managedLists.find(
          item => item.sub_type === "feed" && item.list === "animal_fed"
        ).attribute_lists,
        "animal_fed"
      );
    },
    newSubmission() {
      this.collection = [...this.collection, this.fillSubmission({})];
    },
    fillSubmission(data) {
      data = data || {};
      data = JSON.parse(JSON.stringify(data));
      data.sample_type = this.sampleType
        ? JSON.parse(JSON.stringify(this.sampleType))
        : null;
      data.test_package = this.testPackage
        ? JSON.parse(JSON.stringify(this.testPackage))
        : null;
      if (!data.samples || !data.samples.length) {
        data.samples = [];
        this.testPackageSamples.models.forEach(sample => {
          data.samples = [
            ...data.samples,
            {
              test_package_sample_id: sample.id,
              identifier: sample.name
            }
          ];
        });
      }
      if (data.samples && data.samples.length) {
        data.samples.forEach((sample, index) => {
          sample.sample_feeds = sample.sample_feeds || {
            type: null,
            animal_fed: null
          };
          this.testPackageSamples.models.forEach(testPackageSample => {
            if (testPackageSample.id === sample.test_package_sample_id) {
              sample.test_package_samples = [];
              let temp = JSON.parse(JSON.stringify(testPackageSample));
              sample.test_package_samples = [
                ...sample.test_package_samples,
                temp
              ];
              if (!sample.identifier) {
                sample.identifier = testPackageSample.name;
              }
            }
          });
          data.samples[index] = sample;
        });
      }
      return new Submission(data);
    },
    onSubmissionsChange() {
      this.$emit("onSubmissionsChange", this.collection);
    },
    onSubmissionChange(params) {
      if (params && params.submission && params.index !== null) {
        this.collection.splice(
          params.index,
          1,
          this.fillSubmission(params.submission)
        );
        this.onSubmissionsChange();
      }
    },
    removeSubmission(index) {
      if (index !== null) {
        this.collection.splice(index, 1);
      }
    }
  },
  mounted() {
    this.filterOptionList();
    if (!this.submissions.length) {
      this.newSubmission();
    } else {
      this.submissions.forEach(submission => {
        this.collection = [...this.collection, this.fillSubmission(submission)];
      });
    }
  }
};
</script>
